import "./Minute.css";
import { CSSProperties, useContext } from "react";
import { usePreference } from "../../../context/usePreference";

import { UiContext } from "../../../context/UiContext";
import thousandSeparator from "../../../utils/ThousandSeparator";
import { getDataObjArray } from "../Sidebar/SideBarUtils";
import { getCSSPropertiesHeight, getClassNameByIndice, getStyleByIndice, handleValueDataAudienceIndice } from "./MinuteUtils";
import { SelectTypeGridEnum } from '../../../utils/enums';

export function MinuteTableRow({ rowContent, rowID, selectTypeGrid, heading, headSelected }) {
  const row: string[] = [];
  let headColor = "#000";
  if (headSelected != null) {
    headColor = heading.enabled[headSelected] ? heading.enabled[headSelected].color : "transparent";
  }

  rowContent.map((val, valId) => {
    if (valId > 3) {
      row.push(val);
    }
  });
  const { minuteHeaderWidth2Absolute, isMobile, calculateEmissorasColumn } = useContext(UiContext);

  const u = usePreference();
  const Indice = u.userPreference?.Indice;

  const rowHeight: CSSProperties = getCSSPropertiesHeight(u.userPreference?.TipoBase, Indice);
  let emissoraWidth = calculateEmissorasColumn(heading?.enabled);
  let classColor = rowID % 2 === 0 ? "tableRow" : "tableRow even";
  if (rowContent[2] == "" || rowContent[3] == 0) {
    classColor = "tableRowAlert";
  } else if (parseInt(rowContent[0]) === 1) {
    classColor += " type1";
  } else if (parseInt(rowContent[0]) === 2) {
    classColor += " type2";
  } else {
    classColor += " type3";
  }

  function getCellRowsBackgroundColor(rowIdParam: number) {
    return selectTypeGrid === SelectTypeGridEnum.Image && headSelected != null && headSelected === rowIdParam
      ? headColor
      : "transparent";
  }

  function renderRows(indice) {
    const renderCell = (val) => {
      if (val === "-|-") {
        const splitVal = val.split("|");
        return (
          <div id="audiencedobleIndiceEmpty">
            {splitVal[0]}
            <br />
            <span className="secondary">{splitVal[1]}</span>
          </div>
        );
      } else if (indice !== 5) {
        return (
          <div>
            {thousandSeparator.formatWithSeparator(val.split("|")[0])}
            <br />
            <span className="secondary">
              {val.split("|")[1] === "-"
                ? val.split("|")[1]
                : handleValueDataAudienceIndice(val.split("|")[1], "%")}
            </span>
          </div>
        );
      } else {
        return (
          <div>
            {handleValueDataAudienceIndice(val.split("|")[0], "%")}
            <br />
            <span className="secondary">
              {val.split("|")[1] === "-"
                ? val.split("|")[1]
                : handleValueDataAudienceIndice(val.split("|")[1], "%")}
            </span>
          </div>
        );
      }
    };

    switch (indice) {
      case 0:
        return getDataObjArray(row).map((val, rowID) => (
          <td className="cellRows"
            key={val.ValueId}
            style={{
              fontWeight: selectTypeGrid === SelectTypeGridEnum.Image && headSelected != null && headSelected === rowID ? "bold" : "normal",
              backgroundColor: selectTypeGrid === SelectTypeGridEnum.Image && headSelected != null && headSelected === rowID ? headColor : "transparent",
              textShadow: selectTypeGrid === SelectTypeGridEnum.Image && headSelected != null && headSelected === rowID ? "-1px -1px 0 #fff,1px -1px 0 #fff,    -1px  1px 0 #fff,     1px  1px 0 #fff" : "none",
              width: emissoraWidth + "px",
            }}>
            {val.DataValueArray.split("|")[0] !== undefined && val.DataValueArray.split("|")[0] !== null
              ? thousandSeparator.formatWithSeparator(val.DataValueArray.split("|")[0])
              : ""}
          </td>
        ));
      case 3:
      case 4:
      case 5:
        return getDataObjArray(row).map((val, rowID) => (
          <td className="cellRows"
            key={val.ValueId}
            style={{
              width: emissoraWidth + "px",
              backgroundColor: getCellRowsBackgroundColor(rowID),
              fontWeight: selectTypeGrid === SelectTypeGridEnum.Image && headSelected != null && headSelected === rowID ? "bold" : "normal",
              textShadow: selectTypeGrid === SelectTypeGridEnum.Image && headSelected != null && headSelected === rowID ? "-1px -1px 0 #fff,1px -1px 0 #fff,    -1px  1px 0 #fff,     1px  1px 0 #fff" : "none",
            }}>
            {renderCell(val.DataValueArray)}
          </td>
        ));
      default:
        return getDataObjArray(row).map((val, rowID) => (
          <td className="cellRows"
            key={val.ValueId}
            style={{
              width: emissoraWidth + "px",
              backgroundColor: getCellRowsBackgroundColor(rowID),
              fontWeight: selectTypeGrid === SelectTypeGridEnum.Image && headSelected != null && headSelected === rowID ? "bold" : "normal",
              textShadow: selectTypeGrid === SelectTypeGridEnum.Image && headSelected != null && headSelected === rowID ? "-1px -1px 0 #fff,1px -1px 0 #fff,    -1px  1px 0 #fff,     1px  1px 0 #fff" : "none",

            }}>
            {val.DataValueArray.split("|")[0] !== undefined && val.DataValueArray.split("|")[0] !== null
              ? handleValueDataAudienceIndice(val.DataValueArray.split("|")[0], "%")
              : ""}
          </td>
        ));
    }
  }
  function fixDoubleValue(value) {
    const splitVal = value.split("|");
    if (splitVal.length < 1 || splitVal[0] === "" || splitVal[1] === "")
      return "";
    return (
      <div>
        {thousandSeparator.formatWithSeparator(splitVal[0])}
        <br />
        <span className="secondary">
          {splitVal[1] === "-"
            ? splitVal[1]
            : handleValueDataAudienceIndice(splitVal[1], "%")}
        </span>
      </div>
    );
  }
  return (
    <tr className={classColor} style={rowHeight}>
      {rowContent[2] == "" || rowContent[3] == 0
        ? getDataObjArray(row).map((val) => (
          <td
            className={"tableFirstGridYellow cellRows " + getClassNameByIndice(Indice)}
            key={val.ValueId}
            style={{
              ...getStyleByIndice(Indice),
              width: emissoraWidth + "px",
            }}
          >
            {" "}
            {fixDoubleValue(handleValueDataAudienceIndice(
              val.DataValueArray,
              ""
            ))}
          </td>
        ))
        : renderRows(Indice)}
    </tr>
  );
}